import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['verticalBar', 'horizontalBar'];

  connect() {
    const verticalPercentage = this.verticalBarTarget.dataset.progressBarPercentage;

    requestAnimationFrame(() => {
      this.verticalBarTarget.style.height  = `${verticalPercentage}%`;
    });

    const horizontalPercentage = this.horizontalBarTarget.dataset.progressBarPercentage;

    requestAnimationFrame(() => {
      this.horizontalBarTarget.style.width  = `${horizontalPercentage}%`;
    });
  }
}
